import React, { useEffect } from 'react';
import styles from './ErrorsGraph.module.scss';
import moment from "moment";
import _ from "lodash";
import api from "../../helpers/api";
import TimePeriodSelector from "../miscellaneous/TimePeriodSelector/TimePeriodSelector";
import {$t} from "../../helpers/translator";
import { FaChartPie } from 'react-icons/fa'
import {ResponsivePieCanvas} from '@nivo/pie'
import Loader from "../miscellaneous/Loader/Loader";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";

const ErrorsGraph = (props) => {
    const {clinicId, platformId, onlyGraph, hideBox, showLegend, startDate, endDate, height, width} = props;
    const header = props.header ? props.header : $t('global.service.errorsGraph');
    const userType = props.userType ? props.userType : 2;
    
    const [windowWidth, setWindowWidth] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const [payload, setPayload] = React.useState({
        clinicId: clinicId ? clinicId : '',
        platformId: platformId ? platformId : '',
        startDate: startDate ? moment(startDate) : moment().subtract(1, 'year'),
        endDate: endDate ? moment(endDate) : moment()
    });
    const [originalData, setOriginalData] = React.useState(null);
    const [graphData, setGraphData] = React.useState(null);
    const [selectedDisplayOption, setSelectedDisplayOption] = React.useState([
        {label: $t('global.treatments.byErrorType'), value: 'byErrorType'}
    ]);
    const displayOptions = [
        {label: $t('global.treatments.byErrorType'), value: 'byErrorType'},
        {label: $t('global.treatments.byClinic'), value: 'byClinic'}
    ];

    useEffect(() => {
        setWindowWidth(window.innerHeight + '');
    }, [])

    useEffect(() => {
        setPayload({
            clinicId: clinicId ? clinicId : payload.clinicId,
            platformId: platformId ? platformId : payload.platformId,
            startDate: startDate ? moment(startDate) : payload.startDate,
            endDate: endDate ? moment(endDate) : payload.endDate
        })
    }, [props])

    useEffect(() => {
        getErrorsData()
    }, [payload])

    useEffect(() => {
        if(originalData !== null) {
            restructureData(displayOptions[0].value);
        }
    }, [originalData])

    const getErrorsData = async() => {
        setIsLoading(true);
        try {
            let p = {...payload};
            p.startDate = moment(p.startDate).format('YYYY/MM/DD');
            p.endDate = moment(p.endDate).format('YYYY/MM/DD');

            let res = await api.get(`service/errors?platform_db_id=${p.platformId}&clinic_id=${p.clinicId}&startDate=${p.startDate}&endDate=${p.endDate}`);
            if (res && res.status === 200) {
                setOriginalData(res.data.data);
            }
        } catch (e) {
            console.error('err get platforms:', e);
        } finally {
            setIsLoading(false);
        }
    }

    const restructureData = (type) => {
        let data = {...originalData};
        let graphDataArray = [];

        _.forEach(data[type], (v, k) => {
            graphDataArray.push({
                id: v.title,
                label: v.title,
                value: v.errors,
            })
        })

        setGraphData(graphDataArray);
    }


    const datesChangeHandler = (data) => {
        let p = {...payload};
        p.startDate = data.startDate;
        p.endDate = data.endDate;
        setPayload(p);
        getErrorsData();
    }

    const selectChangeHandler = (name, data) => {
        setSelectedDisplayOption(data)
        restructureData(data.value);
    }

    return (
        <>
            {!isLoading ? <div className={styles.container}>
            <div className={styles.box}>
                <div className={!hideBox ? 'alma-box' : 'w-100 h-100 d-flex'}>
                    <div className={!onlyGraph ? 'alma-box-header' : 'd-none'}>
                        <div>
                            <h3 id="serviceErrorsGraphTitle">{header}</h3>
                        </div>
                    </div>
                    <div className={!onlyGraph ? 'alma-fields-row' : 'd-none'}>
                        <div className={'alma-field-container'}>
                            <div className={'alma-field-header'}>{$t('global.staff.selectTimePeriod')}:</div>
                            <TimePeriodSelector startDate={payload.startDate}
                                                endDate={payload.endDate}
                                                maxDate={payload.startDate}
                                                hideQuarters
                                                onDatesChange={datesChangeHandler.bind(this)}/>
                        </div>
                        {
                            !clinicId  && !platformId && userType !== 2 ?
                                <div className={'alma-field-container'}>
                                    <div className={'alma-field-header'}>{$t('global.treatments.byArea')}</div>
                                    <MultiSelect
                                        options={displayOptions}
                                        selected={selectedDisplayOption}
                                        onValueChange={(data) => selectChangeHandler('display', data)}
                                    />
                                </div>
                                :
                                null
                        }
                    </div>
                    {graphData !== null && Array.isArray(graphData) && graphData.length > 0 ?
                        <div className={styles.graphRow}>
                            <div className={styles.graphContainer} style={{maxWidth: width ? width : '100%', maxHeight: height ? height : '100%' }}>
                                <ResponsivePieCanvas
                                    data={graphData}
                                    margin={{top: 40, right: showLegend ? 200 : 0, bottom: 40, left: 50}}
                                    innerRadius={0.6}
                                    padAngle={0.7}
                                    cornerRadius={5}
                                    activeOuterRadiusOffset={8}
                                    // colors={{scheme: 'reds'}}
                                    colors={[
                                        '#93d5ed',
                                        '#5c9ceb',
                                        '#2e7de4',
                                        '#1d5ba6',
                                    ]}
                                    borderColor="#000000"

                                    arcLinkLabelsSkipAngle={10}
                                    arcLinkLabelsTextColor="#333333"
                                    arcLinkLabelsThickness={2}
                                    arcLinkLabelsColor={{from: 'color'}}
                                    arcLabelsSkipAngle={10}
                                    arcLabelsTextColor="#333333"
                                    defs={[
                                        {
                                            id: 'dots',
                                            type: 'patternDots',
                                            background: 'inherit',
                                            color: 'rgba(255, 255, 255, 0.3)',
                                            size: 4,
                                            padding: 1,
                                            stagger: true
                                        },
                                        {
                                            id: 'lines',
                                            type: 'patternLines',
                                            background: 'inherit',
                                            color: 'rgba(255, 255, 255, 0.3)',
                                            rotation: -45,
                                            lineWidth: 6,
                                            spacing: 10
                                        }
                                    ]}

                                    legends={[
                                        showLegend ?
                                        {
                                            anchor: 'bottom-right',
                                            // anchor: parseInt(windowWidth) < 1024 ? 'bottom' : 'right',
                                            direction: 'column',
                                            justify: false,
                                            translateX: 140,
                                            translateY: 0,
                                            itemsSpacing: 2,
                                            itemWidth: 60,
                                            itemHeight: 14,
                                            itemTextColor: '#999',
                                            itemDirection: 'left-to-right',
                                            itemOpacity: 1,
                                            symbolSize: 14,
                                            symbolShape: 'circle'
                                        } : {}
                                    ]}
                                />
                            </div>
                        </div>
                        : <><div className={ `${styles.noData}` }>
                        <FaChartPie />
                        No data
                    </div></>
                    }
                </div>
            </div>

        </div> : <Loader color="#ddd" />}
        </>
    );
}

export default ErrorsGraph;

